/**
 * Guest (magic-link) routes are standalone screens that must never trigger
 * wallet initialization, auto-reconnect, or MetaMask popups.
 */
export function isGuestRoute() {
    if (typeof window === "undefined")
        return false;
    return isGuestPath(window.location.pathname);
}
/** Route-agnostic variant for reacting to SPA route changes (e.g. useLocation). */
export function isGuestPath(path) {
    return (path.startsWith("/guest-login") ||
        path.startsWith("/guest-chat") ||
        path.startsWith("/guest-dashboard"));
}
/**
 * Wallet providers skip ALL initialization on guest routes and their init
 * effects run only once at mount. Therefore leaving a guest screen for the
 * main application MUST be a full page load — never SPA navigation — so the
 * wallet layer boots from scratch. Any future "open the full app" link on a
 * guest screen must call this helper.
 */
export function exitGuestMode(path = "/login") {
    if (typeof window === "undefined")
        return;
    window.location.assign(path);
}
